/** Shared status / enum mapping helpers (API lowercase ↔ UI Title Case). */

export function toUiStatus(value) {
  if (value == null || value === '') return '';
  const s = String(value);
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}

export function toApiStatus(value) {
  if (value == null || value === '') return value;
  return String(value).toLowerCase();
}

export function toUiOwnerType(value) {
  if (!value) return '';
  const s = String(value).toLowerCase();
  if (s === 'villager') return 'Villager';
  if (s === 'vendor') return 'Vendor';
  return toUiStatus(value);
}

export function toApiOwnerType(value) {
  if (!value) return value;
  return String(value).toLowerCase();
}

export function mapPaginated(result, mapItem) {
  if (!result) return { items: [], total: 0, page: 1, pageSize: 10 };
  const items = Array.isArray(result.items) ? result.items.map(mapItem) : [];
  return {
    items,
    total: result.total ?? items.length,
    page: result.page ?? 1,
    pageSize: result.pageSize ?? (items.length || 10),
  };
}
